import { render, staticRenderFns } from "./DrugAudit.vue?vue&type=template&id=a3a978d4&lang=pug&"
import script from "./DrugAudit.vue?vue&type=script&lang=ts&"
export * from "./DrugAudit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports